import React, { useContext, useEffect } from 'react';
import ProductGrid from '../component/ProductGrid';
import Pager from '../component/Pager';
import { ProductContext } from '../context/ProductContext';

function Products() {
  const { products, loading, total, resetFilters } = useContext(ProductContext);

  useEffect(() => {
    resetFilters();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div>
      <div className="mb-4 flex items-center justify-between">
        <h2 className="text-lg font-bold text-gray-900">All Products</h2>
        <p className="text-sm text-gray-500">{total} products</p>
      </div>
      <ProductGrid products={products} loading={loading} />
      <Pager />
    </div>
  );
}

export default Products;
